export default "__VITE_ASSET__BvPR747l__"